@if(!fieldId){
<div class="col-sm-12" style="padding-inline-start: 0;">
    <app-auto-complete [items]="dropDownData" [searchProperty]="searchProperty" [placeholder]="placeholder"
        (selected)="onSelected($event)" [selectedId]="selectedId" />
    <!-- <app-auto-complete [serviceInstance]="serviceInstance"   [fetchFlag]="fetchFlag" [searchProperty]="searchProperty"
        [placeholder]="placeholder" (selected)="onSelected($event)" [selectedId]="selectedId" /> -->
</div>
}
@else {
<div class="flex align-items-baseline">
    <div class="col-sm-5" style="padding-inline-start: 0;">
        <mat-form-field appearance="outline" class="w-100 m-t-5"
            [ngClass]="{'mat-form-field-compact': size === 'compact','mat-form-field-xs': size === 'xs'}">
            <input matInput type="text" [placeholder]="placeholder" [formControl]="control"
                (input)="onInputSearch($event)">

            <svg class="pc-icon" (click)="popUpShow()">
                <use xlink:href="assets/fonts/custom-icon.svg#custom-search-normal"></use>
            </svg>
        </mat-form-field>
        <app-error [control]="control" [customStyle]="'top:-23px'" />
    </div>
    <div *ngIf="control.value || control.value == 0">
        <!-- <mat-form-field appearance="outline" class="w-100 m-t-5">
                <input matInput type="text"  [formControl]="form.get('name')" disabled>
            </mat-form-field> -->
        <p>{{displayName}}</p>
    </div>
</div>
}
